export const PAYROLL_HISTORY_FILTER_MODEL = {
    year: null,
    period: null,
    set: function (data){
        return {
            ...this,
            year: data?.year ?? null,
            period: data?.period ?? null,
        }
    },
    // Both a year and a period must be selected before fetching.
    isValid: function (){
        return this.year !== null && this.period !== null;
    }
}
